export default __webpack_public_path__ + "static/media/servidor-think-server.8eb5f90f.png";